<router-outlet></router-outlet>

@if (!isEmbeddedForm) {
  <app-chatbot-widget></app-chatbot-widget>
}

@if (loading$ | async; as isLoading) {
  @if (isLoading) {
    <app-global-loader></app-global-loader>
  }
}
